import {Injectable} from '@angular/core';
import {CountAdapter} from '@drl/core/api/adapters/count-adapter.service';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {User} from '@drl/core/auth/models/user.model';

@Injectable()
export class UserPatchAdapter implements IAdapter<User> {
  constructor(private readonly countAdapter: CountAdapter) {}
  adaptToModel(resp: any): any {
    return this.countAdapter.adaptToModel(resp);
  }
  adaptFromModel(data: User): any {
    if (data.email) {
      data.username = data.email;
    }
    if (!data.bio) {
      data.bio = '';
    }
    if (!data.qualification) {
      data.qualification = '';
    }
    if (!data.designation) {
      data.designation = '';
    }
    delete data.lastOtp
    delete data.lastOtpDate;
    delete data?.isAgeEntered;
    delete data?.location;
    delete data?.contigoId;
    delete data?.role;
    return data;
  }
}
